import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=366f18ac&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CHeading: require('@chakra-ui/vue').CHeading, CLink: require('@chakra-ui/vue').CLink, CText: require('@chakra-ui/vue').CText, CFlex: require('@chakra-ui/vue').CFlex, CInput: require('@chakra-ui/vue').CInput})
